import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

function CityList() {
  const { visitor } = useContext(AuthContext);
  const [list, setList] = useState([]);
  const [time, setTime] = useState(0);

  useEffect(() => {
    if (visitor !== null) {
      let newTime = new Date();

      let xtime = newTime.getTime() - time * (24 * 60 * 60 * 1000);

      let dateTime = new Date(xtime);
      let date = dateTime.getDate();

      const newVisitor = visitor.filter((vis) => {
        if (time > 0) {
          return vis.visit_at.toDate().getTime() > dateTime;
        } else {
          return vis.visit_at.toDate().getDate() === date;
        }
      });

      // const compareDate = new Date(tsToMillis - time * (24 * 60 * 60 * 1000));
      // const newVisitor = visitor.filter(
      //   (vis) => vis.visit_at.toDate().getTime() > compareDate
      // );

      const groupBy = (element, key) => {
        return element.reduce((value, x) => {
          (value[x[key]] = value[x[key]] || []).push(x);
          return value;
        }, {});
      };

      const groupArray = groupBy(newVisitor, "city");
      const toArray = Object.values(groupArray);

      const sortArray = toArray.sort(function (a, b) {
        // ASC  -> a.length - b.length ||  DESC -> b.length - a.length
        return b.length - a.length;
      });

      setList(sortArray);
    } else {
      setList([]);
    }
  }, [visitor, time]);

  const changeTime = (e) => {
    setTime(e.target.value);
  };

  return (
    <div className="city-list divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">City List</h5>
        <select className="custom-select" onChange={changeTime}>
          <option value="0">today</option>
          <option value="3">last 3 days</option>
          <option value="7">last 1 week</option>
          <option value="30">last 1 month</option>
        </select>
      </div>
      <table className="table-head">
        <thead className="text textBold">
          <tr>
            <td>No</td>
            <td>Name</td>
            <td>Visitor</td>
          </tr>
        </thead>
      </table>
      <div className="wrap-table">
        {list.length > 0 ? (
          <table className="table-list">
            <tbody className="text">
              {list.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      {data[0].city},{" "}
                      <span className="textSmall">
                        ({data[0].country_code})
                      </span>
                    </td>
                    <td>{new Intl.NumberFormat().format(data.length)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className="darktextColor text not-available">
            Data is not Available!
          </p>
        )}
      </div>
    </div>
  );
}

export default CityList;
